/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Injectable } from '@angular/core';
import { CustomerPreferenceService } from './customerpreference.service';
import { CommonConstants } from '../../common/constants/common-constants';
import { CustomerPreferenceResponse } from './customerpreference.model';

@Injectable()
export class CustomerPreferenceUtil {
    public static customerPortalTabsEnabled: Set<string> = new Set<string>();
    canViewIncidents: boolean;
    canEditIncidents: boolean;
    canCreateIncidents: boolean;
    canViewServiceRequests: boolean;
    canEditServiceRequests: boolean;
    canCreateServiceRequests: boolean;
    canViewChangeRequests: boolean;
    canEditChangeRequests: boolean;
    canCreateChangeRequests: boolean;
    appStoreCustomerEnable: boolean;
    itemSelectionRequired: boolean;
    showService: boolean;
    canViewItems: boolean;
    canCustomerViewOutages: boolean;
    canCusotmerViewPlannedOutages: boolean;
    defaultTab: number;
    showNotifyField: boolean;

    readonly REQUESTS_INDEX_SERVER = 1;
    readonly STORE_INDEX_SERVER = 2;

    readonly HOME_INDEX = '0';
    readonly STORE_INDEX = '1';
    readonly REQUESTS_INDEX = '2';

    constructor(public customerPreferenceService: CustomerPreferenceService) {
    }

    /*
    This method has to be in sync with old portal code (ref CustomerMenu.getAvailablePagesForNewPortal)
    */
    setPrivilgesBasedPreferences(): any {
        return this.customerPreferenceService.getPreferenceList().toPromise().
            then((preference: CustomerPreferenceResponse) => {
                localStorage.removeItem('cusPref');

                CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.HOME_COMPONENT);

                // privilege check to show store tab
                this.appStoreCustomerEnable = preference.appStoreCustomerEnable;
                if (this.appStoreCustomerEnable) {
                    CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.STORE_COMPONENT);
                }


                this.canViewIncidents = preference.canViewIncidents;
                this.canEditIncidents = preference.canEditIncidents;
                this.canViewServiceRequests = preference.canViewServiceRequests;
                this.canEditServiceRequests = preference.canEditServiceRequests;
                this.canViewChangeRequests = preference.canViewChangeRequests;
                this.canEditChangeRequests = preference.canEditChangeRequests;


                // privilege check to show Request tab
                if (this.canViewIncidents || this.canEditIncidents || this.canViewServiceRequests ||
                    this.canEditServiceRequests || this.canViewChangeRequests || this.canEditChangeRequests) {
                    CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.REQUEST_COMPONENT);
                }

                // privilege check to show Service tab
                this.showService = preference.showService;
                if (this.showService) {
                    CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.SERVICES_COMPONENT);
                }

                // privilege check to show Item tab
                this.canViewItems = preference.canViewItems;
                if (this.canViewItems) {
                    CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.ITEMS_COMPONENT);
                }

                // no check for self-help
                CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.SELFHELP_COMPONENT);

                // privilege check to show outages tab
                this.canCustomerViewOutages = preference.canCustomerViewOutages;
                this.canCusotmerViewPlannedOutages = preference.canCusotmerViewPlannedOutages;
                if (this.canCustomerViewOutages || this.canCusotmerViewPlannedOutages) {
                    CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.OUTAGES_COMPONENT);
                }

                // privilege check to show Report-incident
                this.canCreateIncidents = preference.canCreateIncidents;
                if (this.canCreateIncidents) {
                    CustomerPreferenceUtil.customerPortalTabsEnabled.add(CommonConstants.REPORT_INCIDENT_COMPONENT);
                }

                // Privilges to check notify field
                this.showNotifyField = preference.showNotify;
                // storing the preferences in local storage to load during refresh
                localStorage.setItem('cusPref', JSON.stringify(Array.from(CustomerPreferenceUtil.customerPortalTabsEnabled)));
                this.deriveDefaultTab(preference);

            });
    }

    /*
    This method has to be in sync with old portal code (ref CustomerMenu.getDefaultTabForNewPortal)
    */
    private deriveDefaultTab(preference: CustomerPreferenceResponse) {
        switch (preference.defaultTab) {
            case this.STORE_INDEX_SERVER:
                localStorage.setItem('defaultTab', this.STORE_INDEX);
                break;
            case this.REQUESTS_INDEX_SERVER:
                localStorage.setItem('defaultTab', this.REQUESTS_INDEX);
                break;
            default: localStorage.setItem('defaultTab', this.HOME_INDEX);
        }
    }
}
